import { z } from "zod";
export const transactionSubtypes = [
    "Assignment",
    "Buy",
    "Buy of Accrued Interest",
    "Cash Deposit",
    "Cash in Lieu",
    "Cash Withdrawal",
    "Conversion In",
    "Conversion Out",
    "Dividend Reinvestment",
    "Dividend",
    "Expense",
    "Income Reinvestment",
    "Income",
    "Interest Reinvestment",
    "Interest",
    "Journal",
    "Long-Term",
    "Management Fee",
    "Merger",
    "Non-Qualified",
    "Non-Taxable",
    "Qualified",
    "Redemption",
    "Return of Capital",
    "Reverse Split",
    "Sale",
    "Sale of Accrued Interest",
    "Short-Term",
    "Spinoff",
    "Split",
    "Tax Withholding",
    "Tax-Exempt",
    "Transfer In",
    "Transfer Out",
    "Unknown",
];
export const TransactionSubtypeEnum = z.enum(transactionSubtypes);
export const TransactionSubtype = z.union([
    TransactionSubtypeEnum.transform((str) => ({
        type: str,
    })),
    z
        .string()
        .transform((str) => ({ type: "@Unknown", value: str })),
]);
export function getTransactionSubtype(t) {
    if (t.type === "@Unknown") {
        return t.value;
    }
    return t.type;
}
//# sourceMappingURL=transactionSubtype.js.map